<template>
   <div class="region-select-form">
      <div
         class='select-input-wrapper'
         v-for="region in [state, district, municipality]"
         :key="`region-selector-${region.name}`"
         >
         <select-input
            v-model="region.selected"
            :options='region.options.map(option => ({...option, value: option.code}))'
            color="primary"
            font="'Nunito', Arial, 'sans-serif'"
            no-carret
            @input="selectRegion(region.name, parseInt(region.selected))"
         />
      </div>
   </div>
</template>

<script>
import SelectInput from '../../../atoms/Home/SelectInput'; 

import { mapActions } from 'vuex';
import { noneSelectValues } from '../../../../js/mapNavigator/baseClasses';
import { getNavigator } from '../../../../js/mapNavigator';
import { getLayerById } from '../../../../js/layers';
import { showLoading, hideLoading } from '../../../../js/ui-helpers';
import { bus } from '../../../../main';
import { getMap } from '../../../../js/map';
import { allStates } from '../../../../js/constants';

export default {
   name: 'region-select-form',
   created()
   {
      bus.$on('navigator-initialized', navigator =>
      {
         navigator.country.beforeSelect = navigator.state.beforeSelect =
         navigator.district.beforeSelect = navigator.municipality.beforeSelect = async () =>
         {
            showLoading();
         };
         navigator.country.afterSelect = async code =>
         {
            this.updateSelectRegion('All Provinces');
            await this.fetchInfographicsData({ adminid: code });
            this.clearRegion(this.district);
            this.clearRegion(this.municipality);
            hideLoading();
         };
         
         navigator.state.afterSelect = async scode =>
         {
            this.state.selected = scode;
            this.district.options = await navigator.district.getSelectionOptions();
            this.district.selected = 0;
            this.clearRegion(this.municipality);
            
            this.updateSelectRegion(this.getRegionName(this.state, scode));
            await this.fetchInfographicsData({ adminid: scode });
            this.municipality.options = noneSelectValues;
            hideLoading();
         };

         navigator.district.afterSelect = async dcode =>
         {
            this.district.selected = dcode;
            this.municipality.options = await navigator.municipality.getSelectionOptions();
            this.municipality.selected = 0;
            
            const { state: {currentCode: scode} } = navigator;
            const formattedDCode = parseInt(dcode) >= 10 ? dcode : `0${dcode}`;
            
            this.updateSelectRegion(this.getRegionName(this.district, dcode));
            await this.fetchInfographicsData({ adminid: `${scode}${formattedDCode}` });
            hideLoading();
         };

         navigator.municipality.afterSelect = async sddmm =>
         {
            this.municipality.selected = sddmm;
            const maskLayer = getLayerById('gaunagar-mask', getMap());
            if (maskLayer)
            {
               const params = maskLayer.getSource().getParams();
               params.CQL_FILTER = `SDDMM<>${this.municipality.selected}`;
               maskLayer.getSource().updateParams(params);
            }
            this.updateSelectRegion(this.getRegionName(this.municipality, sddmm));
            await this.fetchInfographicsData({ adminid: sddmm, isMunicipality: true });
            hideLoading();
         };
      });
   },
   data()
   {
      return {
         state: {
            name: 'state',
            options: allStates,
            selected: 0,
         },
         district: {
            name: 'district',
            options: noneSelectValues,
            selected: -1,
         },
         municipality: {
            name: 'municipality',
            options: noneSelectValues,
            selected: -1,
         },
      }
   },
   components: {
      SelectInput,
   },
   methods: {
      ...mapActions('infographics', ['updateSelectRegion', 'fetchInfographicsData']),
      selectRegion(regionName, selected)
      {
         if (regionName===this.state.name)
         {
            getNavigator().state.select(selected);
         }
         else if (regionName===this.district.name)
         {
            getNavigator().district.select(selected);
         }
         else if (regionName===this.municipality.name)
         {
            getNavigator().municipality.select(selected)
         }
      },
      getRegionName(region, code)
      {
         const selected = region.options.find(option => option.code===code);
         return selected ? selected.title : 'Not found';
      },
      clearRegion(region)
      {
         region.options = noneSelectValues;
         region.selected = -1;
      }
   }
}
</script>

<style lang='scss' scoped>
.region-select-form
{
   display: flex;
   align-items: center;

   .select-input-wrapper {
      min-width: 15ch;
      max-width: 15ch;
      margin: 2px;
   }
}

</style>
